var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill: none;\n      }\n\n      .cls-8 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19 {\n        font-size: 5.45px;\n      }\n\n      .cls-20 {\n        letter-spacing: 0em;\n      }\n\n      .cls-21 {\n        letter-spacing: 0em;\n      }\n\n      .cls-22 {\n        letter-spacing: .02em;\n      }\n\n      .cls-23 {\n        letter-spacing: .02em;\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-24, .cls-25, .cls-26 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-25 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-9 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-27 {\n        letter-spacing: .03em;\n      }\n\n      .cls-28 {\n        letter-spacing: 0em;\n      }\n\n      .cls-29 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-30 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-31 {\n        letter-spacing: 0em;\n      }\n\n      .cls-32 {\n        letter-spacing: 0em;\n      }\n\n      .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44 {\n        font-size: 9.27px;\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-33 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-46 {\n        letter-spacing: .03em;\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-48 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-49 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-34 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-50 {\n        letter-spacing: .01em;\n      }\n\n      .cls-35 {\n        letter-spacing: 0em;\n      }\n\n      .cls-10 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-51 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        stroke-width: .32px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-6 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-4, .cls-7 {\n        stroke: #fff;\n      }\n\n      .cls-52 {\n        fill: #f7eedd;\n      }\n\n      .cls-53 {\n        fill: #f4f4f6;\n      }\n\n      .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59 {\n        fill: #fff;\n      }\n\n      .cls-60 {\n        fill: #999;\n      }\n\n      .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68 {\n        fill: #333;\n      }\n\n      .cls-69 {\n        fill: #0a78dd;\n      }\n\n      .cls-70 {\n        fill: #51c6e5;\n      }\n\n      .cls-71 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-72 {\n        letter-spacing: 0em;\n      }\n\n      .cls-73 {\n        letter-spacing: 0em;\n      }\n\n      .cls-74 {\n        letter-spacing: 0em;\n      }\n\n      .cls-62, .cls-55 {\n        font-size: 5.96px;\n      }\n\n      .cls-62, .cls-65, .cls-68 {\n        font-family: Bitter-Light, 'Bitter Light';\n        font-weight: 300;\n      }\n\n      .cls-36 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-55, .cls-56, .cls-63, .cls-57, .cls-59 {\n        font-family: Bitter-Regular, 'Bitter Regular';\n      }\n\n      .cls-11 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-12 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3, .cls-5, .cls-6 {\n        stroke: #333;\n      }\n\n      .cls-3, .cls-7 {\n        stroke-width: 1.03px;\n      }\n\n      .cls-75 {\n        letter-spacing: 0em;\n      }\n\n      .cls-76 {\n        letter-spacing: 0em;\n      }\n\n      .cls-77 {\n        letter-spacing: 0em;\n      }\n\n      .cls-78 {\n        letter-spacing: 0em;\n      }\n\n      .cls-79 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        stroke-width: .52px;\n      }\n\n      .cls-80 {\n        letter-spacing: 0em;\n      }\n\n      .cls-81 {\n        letter-spacing: .02em;\n      }\n\n      .cls-37 {\n        letter-spacing: .02em;\n      }\n\n      .cls-5, .cls-6 {\n        stroke-width: .45px;\n      }\n\n      .cls-5, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-82 {\n        letter-spacing: .02em;\n      }\n\n      .cls-38 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-83 {\n        letter-spacing: 0em;\n      }\n\n      .cls-84 {\n        font-size: 7.27px;\n        letter-spacing: 0em;\n      }\n\n      .cls-85 {\n        letter-spacing: 0em;\n      }\n\n      .cls-13 {\n        letter-spacing: .01em;\n      }\n\n      .cls-86 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-87 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-56, .cls-68 {\n        font-size: 3.5px;\n      }\n\n      .cls-88 {\n        letter-spacing: 0em;\n      }\n\n      .cls-89 {\n        letter-spacing: 0em;\n      }\n\n      .cls-40 {\n        letter-spacing: 0em;\n      }\n\n      .cls-90 {\n        letter-spacing: 0em;\n      }\n\n      .cls-41 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-91 {\n        letter-spacing: 0em;\n      }\n\n      .cls-42 {\n        letter-spacing: 0em;\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-95 {\n        letter-spacing: 0em;\n      }\n\n      .cls-43 {\n        letter-spacing: .01em;\n      }\n\n      .cls-96 {\n        letter-spacing: 0em;\n      }\n\n      .cls-97 {\n        letter-spacing: 0em;\n      }\n\n      .cls-98 {\n        letter-spacing: 0em;\n      }\n\n      .cls-99 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-100 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-64 {\n        font-size: 14px;\n      }\n\n      .cls-64, .cls-66, .cls-67 {\n        font-family: DINPro-BlackItalic, 'DIN Pro';\n        font-style: italic;\n        font-weight: 800;\n      }\n\n      .cls-57 {\n        font-size: 4.24px;\n      }\n\n      .cls-101 {\n        letter-spacing: 0em;\n      }\n\n      .cls-102 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-15 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-65, .cls-59 {\n        font-size: 2.15px;\n      }\n\n      .cls-103 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-104 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-66 {\n        font-size: 25.23px;\n      }\n\n      .cls-105 {\n        letter-spacing: 0em;\n      }\n\n      .cls-106 {\n        letter-spacing: 0em;\n      }\n\n      .cls-16 {\n        letter-spacing: .02em;\n      }\n\n      .cls-107 {\n        isolation: isolate;\n      }\n\n      .cls-108 {\n        letter-spacing: 0em;\n      }\n\n      .cls-109 {\n        letter-spacing: 0em;\n      }\n\n      .cls-110 {\n        letter-spacing: 0em;\n      }\n\n      .cls-111 {\n        letter-spacing: 0em;\n      }\n\n      .cls-112 {\n        letter-spacing: 0em;\n      }\n\n      .cls-67 {\n        font-size: 11px;\n      }\n\n      .cls-113 {\n        letter-spacing: 0em;\n      }\n\n      .cls-17 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-114 {\n        font-size: 12.36px;\n      }\n\n      .cls-115 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-116 {\n        letter-spacing: 0em;\n      }\n\n      .cls-117 {\n        letter-spacing: .01em;\n      }\n\n      .cls-118 {\n        letter-spacing: 0em;\n      }\n\n      .cls-119 {\n        letter-spacing: .01em;\n      }\n\n      .cls-44 {\n        letter-spacing: 0em;\n      }\n\n      .cls-18 {\n        letter-spacing: 0em;\n      }\n\n      .cls-120 {\n        letter-spacing: 0em;\n      }\n\n      .cls-121 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-122 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-58 {\n        mix-blend-mode: overlay;\n        opacity: .3;\n      }\n\n      .cls-123 {\n        letter-spacing: 0em;\n      }\n\n      .cls-124 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-19 {\n        letter-spacing: 0em;\n      }\n\n      .cls-125 {\n        letter-spacing: 0em;\n      }\n\n      .cls-126 {\n        letter-spacing: 0em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1107.81,567.24l-17.59-61.47h14.2l10.17,42.71h.51l11.22-42.71h12.16l11.19,42.8h.54l10.17-42.8h14.2l-17.59,61.47h-12.67l-11.71-40.19h-.48l-11.67,40.19h-12.67Zm89.5.9c-4.74,0-8.82-.97-12.23-2.9-3.41-1.93-6.04-4.67-7.88-8.22-1.84-3.55-2.76-7.76-2.76-12.62s.92-8.9,2.76-12.49c1.84-3.58,4.44-6.37,7.79-8.37,3.35-2,7.29-3,11.81-3,3.04,0,5.88.49,8.51,1.46,2.63.97,4.93,2.43,6.9,4.37s3.51,4.38,4.61,7.31c1.1,2.93,1.65,6.36,1.65,10.28v3.51h-38.93v-7.92h26.89c0-1.84-.4-3.47-1.2-4.89-.8-1.42-1.91-2.54-3.32-3.35-1.41-.81-3.05-1.21-4.91-1.21s-3.66.45-5.15,1.33c-1.49.89-2.66,2.08-3.5,3.57-.84,1.49-1.27,3.15-1.29,4.97v7.53c0,2.28.42,4.25,1.28,5.91.85,1.66,2.06,2.94,3.62,3.84s3.41,1.35,5.55,1.35c1.42,0,2.72-.2,3.9-.6,1.18-.4,2.19-1,3.03-1.8.84-.8,1.48-1.78,1.92-2.94l11.82.78c-.6,2.84-1.83,5.32-3.68,7.43-1.85,2.11-4.23,3.75-7.14,4.92-2.91,1.17-6.27,1.76-10.07,1.76Zm29.74-.9v-61.47h12.79v23.11h.39c.56-1.24,1.38-2.51,2.45-3.8,1.07-1.29,2.47-2.37,4.2-3.24,1.73-.87,3.89-1.31,6.47-1.31,3.36,0,6.46.88,9.3,2.63s5.11,4.38,6.81,7.89c1.7,3.51,2.55,7.91,2.55,13.19s-.83,9.48-2.48,13.01c-1.65,3.53-3.89,6.2-6.72,8.01s-6,2.72-9.5,2.72c-2.48,0-4.59-.41-6.32-1.23s-3.15-1.86-4.25-3.11c-1.1-1.25-1.94-2.52-2.52-3.8h-.57v7.38h-12.61Zm12.52-23.05c0,2.74.38,5.13,1.14,7.17.76,2.04,1.86,3.63,3.3,4.76,1.44,1.13,3.19,1.7,5.25,1.7s3.84-.58,5.28-1.73c1.44-1.15,2.54-2.75,3.29-4.8.75-2.05,1.12-4.42,1.12-7.1s-.37-5-1.11-7.02c-.74-2.02-1.83-3.6-3.27-4.74s-3.21-1.71-5.31-1.71-3.84.55-5.27,1.65c-1.43,1.1-2.53,2.66-3.29,4.68-.76,2.02-1.14,4.4-1.14,7.14Zm79.29-9.9l-11.71.72c-.2-1-.63-1.91-1.29-2.72-.66-.81-1.53-1.46-2.6-1.95s-2.35-.74-3.83-.74c-1.98,0-3.65.42-5.01,1.25-1.36.83-2.04,1.94-2.04,3.32,0,1.1.44,2.03,1.32,2.79.88.76,2.39,1.37,4.53,1.83l8.34,1.68c4.48.92,7.82,2.4,10.02,4.44,2.2,2.04,3.3,4.72,3.3,8.04,0,3.02-.88,5.67-2.66,7.95-1.77,2.28-4.19,4.06-7.26,5.33s-6.61,1.91-10.61,1.91c-6.1,0-10.96-1.28-14.57-3.83-3.61-2.55-5.73-6.03-6.35-10.43l12.58-.66c.38,1.86,1.3,3.28,2.76,4.25,1.46.97,3.33,1.46,5.61,1.46s4.05-.44,5.42-1.31,2.07-2,2.09-3.38c-.02-1.16-.51-2.12-1.47-2.87-.96-.75-2.44-1.33-4.44-1.73l-7.98-1.59c-4.5-.9-7.85-2.46-10.04-4.68-2.19-2.22-3.29-5.05-3.29-8.49,0-2.96.8-5.51,2.42-7.65,1.61-2.14,3.88-3.79,6.81-4.95,2.93-1.16,6.37-1.74,10.31-1.74,5.82,0,10.41,1.23,13.76,3.69,3.35,2.46,5.31,5.81,5.87,10.05Zm15.54-19.09c-1.9,0-3.53-.63-4.88-1.91s-2.03-2.8-2.03-4.58.67-3.28,2.03-4.55,2.98-1.91,4.88-1.91,3.53.63,4.88,1.91,2.03,2.79,2.03,4.55-.68,3.31-2.03,4.58-2.98,1.91-4.88,1.91Zm-6.42,52.04v-46.1h12.79v46.1h-12.79Zm47.51-46.1v9.6h-27.76v-9.6h27.76Zm-21.46-11.04h12.79v42.98c0,1.18.18,2.1.54,2.75.36.65.87,1.11,1.52,1.37.65.26,1.41.39,2.27.39.6,0,1.2-.05,1.8-.17.6-.11,1.06-.2,1.38-.25l2.01,9.51c-.64.2-1.54.43-2.7.71-1.16.27-2.57.44-4.23.5-3.08.12-5.78-.29-8.09-1.23s-4.11-2.4-5.39-4.38-1.91-4.48-1.89-7.5v-44.66Zm50.3,58.04c-4.74,0-8.82-.97-12.23-2.9-3.41-1.93-6.04-4.67-7.88-8.22-1.84-3.55-2.76-7.76-2.76-12.62s.92-8.9,2.76-12.49c1.84-3.58,4.44-6.37,7.79-8.37,3.35-2,7.29-3,11.81-3,3.04,0,5.88.49,8.51,1.46,2.63.97,4.93,2.43,6.9,4.37s3.51,4.38,4.61,7.31c1.1,2.93,1.65,6.36,1.65,10.28v3.51h-38.93v-7.92h26.89c0-1.84-.4-3.47-1.2-4.89-.8-1.42-1.91-2.54-3.32-3.35-1.41-.81-3.05-1.21-4.91-1.21s-3.66.45-5.15,1.33c-1.49.89-2.66,2.08-3.5,3.57-.84,1.49-1.27,3.15-1.29,4.97v7.53c0,2.28.42,4.25,1.28,5.91.85,1.66,2.06,2.94,3.62,3.84s3.41,1.35,5.55,1.35c1.42,0,2.72-.2,3.9-.6,1.18-.4,2.19-1,3.03-1.8.84-.8,1.48-1.78,1.92-2.94l11.82.78c-.6,2.84-1.83,5.32-3.68,7.43-1.85,2.11-4.23,3.75-7.14,4.92-2.91,1.17-6.27,1.76-10.07,1.76Zm67.95,0c-4.24,0-7.9-.76-10.99-2.28s-5.45-3.59-7.1-6.2c-1.65-2.61-2.48-5.53-2.48-8.75,0-2.4.48-4.53,1.44-6.39.96-1.86,2.3-3.58,4.02-5.15,1.72-1.57,3.72-3.14,6-4.7l11.92-7.83c1.54-.98,2.67-2.02,3.39-3.11.72-1.09,1.08-2.28,1.08-3.56s-.49-2.35-1.47-3.39c-.98-1.04-2.37-1.55-4.17-1.53-1.2,0-2.24.27-3.12.79-.88.53-1.57,1.22-2.06,2.07-.49.85-.74,1.8-.74,2.84,0,1.28.36,2.58,1.08,3.9.72,1.32,1.68,2.72,2.88,4.19,1.2,1.47,2.51,3.06,3.93,4.76l29.14,33.43h-13.33l-24.31-27.07c-1.6-1.82-3.2-3.73-4.79-5.72-1.59-1.99-2.92-4.11-3.98-6.36s-1.59-4.7-1.59-7.34c0-2.98.7-5.66,2.09-8.04s3.35-4.27,5.87-5.66c2.52-1.39,5.46-2.08,8.82-2.08s6.12.67,8.51,2c2.39,1.33,4.23,3.09,5.52,5.28,1.29,2.19,1.94,4.6,1.94,7.22,0,2.9-.71,5.53-2.15,7.88-1.43,2.35-3.44,4.46-6.02,6.32l-12.54,9.03c-1.7,1.24-2.96,2.51-3.77,3.8-.81,1.29-1.22,2.53-1.22,3.71,0,1.46.36,2.77,1.08,3.93.72,1.16,1.74,2.08,3.06,2.75,1.32.67,2.87,1,4.65,1,2.16,0,4.3-.5,6.41-1.49,2.11-.99,4.03-2.4,5.76-4.23,1.73-1.83,3.12-4.01,4.16-6.53,1.04-2.52,1.56-5.31,1.56-8.37h10.59c0,3.76-.41,7.15-1.23,10.16-.82,3.01-1.96,5.63-3.42,7.86-1.46,2.23-3.13,4.06-5.01,5.48-.6.38-1.18.74-1.74,1.08-.56.34-1.14.7-1.74,1.08-2.28,1.84-4.83,3.17-7.64,3.99-2.81.82-5.59,1.23-8.33,1.23Zm71.79-.9l-17.59-61.47h14.2l10.17,42.71h.51l11.22-42.71h12.16l11.19,42.8h.54l10.17-42.8h14.2l-17.59,61.47h-12.67l-11.71-40.19h-.48l-11.67,40.19h-12.67Zm89.5.9c-4.74,0-8.82-.97-12.23-2.9-3.41-1.93-6.04-4.67-7.88-8.22-1.84-3.55-2.76-7.76-2.76-12.62s.92-8.9,2.76-12.49c1.84-3.58,4.44-6.37,7.79-8.37,3.35-2,7.29-3,11.81-3,3.04,0,5.88.49,8.51,1.46,2.63.97,4.93,2.43,6.9,4.37s3.51,4.38,4.61,7.31c1.1,2.93,1.65,6.36,1.65,10.28v3.51h-38.93v-7.92h26.89c0-1.84-.4-3.47-1.2-4.89-.8-1.42-1.91-2.54-3.32-3.35-1.41-.81-3.05-1.21-4.91-1.21s-3.66.45-5.15,1.33c-1.49.89-2.66,2.08-3.5,3.57-.84,1.49-1.27,3.15-1.29,4.97v7.53c0,2.28.42,4.25,1.28,5.91.85,1.66,2.06,2.94,3.62,3.84s3.41,1.35,5.55,1.35c1.42,0,2.72-.2,3.9-.6,1.18-.4,2.19-1,3.03-1.8.84-.8,1.48-1.78,1.92-2.94l11.82.78c-.6,2.84-1.83,5.32-3.68,7.43-1.85,2.11-4.23,3.75-7.14,4.92-2.91,1.17-6.27,1.76-10.07,1.76Zm29.74-.9v-61.47h12.79v23.11h.39c.56-1.24,1.38-2.51,2.45-3.8,1.07-1.29,2.47-2.37,4.2-3.24,1.73-.87,3.89-1.31,6.47-1.31,3.36,0,6.46.88,9.3,2.63s5.11,4.38,6.81,7.89c1.7,3.51,2.55,7.91,2.55,13.19s-.83,9.48-2.48,13.01c-1.65,3.53-3.89,6.2-6.72,8.01s-6,2.72-9.5,2.72c-2.48,0-4.59-.41-6.32-1.23s-3.15-1.86-4.25-3.11c-1.1-1.25-1.94-2.52-2.52-3.8h-.57v7.38h-12.61Zm12.52-23.05c0,2.74.38,5.13,1.14,7.17.76,2.04,1.86,3.63,3.3,4.76,1.44,1.13,3.19,1.7,5.25,1.7s3.84-.58,5.28-1.73c1.44-1.15,2.54-2.75,3.29-4.8.75-2.05,1.12-4.42,1.12-7.1s-.37-5-1.11-7.02c-.74-2.02-1.83-3.6-3.27-4.74s-3.21-1.71-5.31-1.71-3.84.55-5.27,1.65c-1.43,1.1-2.53,2.66-3.29,4.68-.76,2.02-1.14,4.4-1.14,7.14Zm71.37,23.05h-13.93l21.22-61.47h16.75l21.19,61.47h-13.93l-15.4-47.42h-.48l-15.43,47.42Zm-.87-24.16h32.89v10.14h-32.89v-10.14Zm53.24,41.45v-63.39h12.6v7.74h.57c.56-1.24,1.38-2.51,2.45-3.8,1.07-1.29,2.47-2.37,4.2-3.24,1.73-.87,3.89-1.31,6.47-1.31,3.36,0,6.46.88,9.3,2.63s5.11,4.38,6.81,7.89c1.7,3.51,2.55,7.91,2.55,13.19s-.83,9.48-2.48,13.01c-1.65,3.53-3.89,6.2-6.72,8.01s-6,2.72-9.5,2.72c-2.48,0-4.59-.41-6.32-1.23s-3.15-1.86-4.25-3.11c-1.1-1.25-1.94-2.52-2.52-3.8h-.39v24.67h-12.79Zm12.51-40.34c0,2.74.38,5.13,1.14,7.17.76,2.04,1.86,3.63,3.3,4.76,1.44,1.13,3.19,1.7,5.25,1.7s3.84-.58,5.28-1.73c1.44-1.15,2.54-2.75,3.29-4.8.75-2.05,1.12-4.42,1.12-7.1s-.37-5-1.11-7.02c-.74-2.02-1.83-3.6-3.27-4.74-1.44-1.14-3.21-1.71-5.31-1.71s-3.84.55-5.27,1.65c-1.43,1.1-2.53,2.66-3.29,4.68-.76,2.02-1.14,4.4-1.14,7.14Zm40.94,40.34v-63.39h12.6v7.74h.57c.56-1.24,1.38-2.51,2.45-3.8,1.07-1.29,2.47-2.37,4.2-3.24,1.73-.87,3.89-1.31,6.47-1.31,3.36,0,6.46.88,9.3,2.63s5.11,4.38,6.81,7.89c1.7,3.51,2.55,7.91,2.55,13.19s-.83,9.48-2.48,13.01c-1.65,3.53-3.89,6.2-6.72,8.01s-6,2.72-9.5,2.72c-2.48,0-4.59-.41-6.32-1.23s-3.15-1.86-4.25-3.11c-1.1-1.25-1.94-2.52-2.52-3.8h-.39v24.67h-12.79Zm12.51-40.34c0,2.74.38,5.13,1.14,7.17.76,2.04,1.86,3.63,3.3,4.76,1.44,1.13,3.19,1.7,5.25,1.7s3.84-.58,5.28-1.73c1.44-1.15,2.54-2.75,3.29-4.8.75-2.05,1.12-4.42,1.12-7.1s-.37-5-1.11-7.02c-.74-2.02-1.83-3.6-3.27-4.74-1.44-1.14-3.21-1.71-5.31-1.71s-3.84.55-5.27,1.65c-1.43,1.1-2.53,2.66-3.29,4.68-.76,2.02-1.14,4.4-1.14,7.14Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1073.68,
    y1: 652.58,
    x2: 1945.99,
    y2: 418.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -385.98,
    cy: -1503.42,
    fx: -385.98,
    fy: -1503.42,
    r: 469.39,
    gradientTransform: "translate(638.13 710) rotate(.03) scale(.51 .01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#d5d7dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f3f4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 46.83,
    cy: -1472.83,
    fx: 46.83,
    fy: -1472.83,
    r: 469.39,
    gradientTransform: "translate(638.12 721.91) rotate(.03) scale(.51 .01)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 777.25,
    cy: -1454.37,
    fx: 777.25,
    fy: -1454.37,
    r: 469.35,
    gradientTransform: "translate(675.12 729.35) rotate(.04) scale(.32 .01)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 496.23,
    y1: 609.47,
    x2: 496.23,
    y2: 242.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#293445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 725.82,
    y1: 691.41,
    x2: 799.03,
    y2: 402.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 895.81,
    y1: 608.91,
    x2: 998.68,
    y2: 608.91,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    width: 2000,
    height: 900
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1065.43,
    y: 449.65,
    width: 888.82,
    height: 172.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1115.21,474.85v-26.18h9.33c2.04,0,3.72.37,5.06,1.11,1.34.74,2.34,1.75,3,3.04.67,1.28,1,2.72,1,4.33s-.33,3.06-1,4.34c-.67,1.28-1.67,2.3-3.02,3.04-1.34.75-3.03,1.12-5.06,1.12h-6.42v-3.35h6.06c1.29,0,2.33-.22,3.13-.67.8-.45,1.39-1.06,1.76-1.83s.56-1.66.56-2.65-.19-1.87-.56-2.63c-.38-.77-.97-1.37-1.77-1.8-.81-.44-1.87-.65-3.18-.65h-4.96v22.79h-3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1145.94,475.24c-1.84,0-3.45-.42-4.82-1.27-1.37-.84-2.44-2.02-3.2-3.54-.76-1.52-1.14-3.29-1.14-5.32s.38-3.82,1.14-5.34c.76-1.53,1.82-2.71,3.2-3.55,1.37-.84,2.98-1.27,4.82-1.27s3.45.42,4.82,1.27c1.37.84,2.44,2.03,3.2,3.55.76,1.53,1.14,3.31,1.14,5.34s-.38,3.8-1.14,5.32c-.76,1.52-1.82,2.7-3.2,3.54-1.37.84-2.98,1.27-4.82,1.27Zm.01-3.21c1.19,0,2.18-.32,2.97-.95.78-.63,1.37-1.47,1.75-2.52.38-1.05.57-2.2.57-3.46s-.19-2.41-.57-3.46-.96-1.9-1.75-2.54c-.78-.64-1.77-.96-2.97-.96s-2.2.32-2.99.96c-.79.64-1.37,1.49-1.75,2.54-.38,1.05-.57,2.21-.57,3.46s.19,2.42.57,3.46c.38,1.05.96,1.89,1.75,2.52.79.63,1.78.95,2.99.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1163.01,474.85l-5.78-19.64h3.95l3.85,14.42h.19l3.86-14.42h3.95l3.84,14.36h.19l3.82-14.36h3.95l-5.77,19.64h-3.9l-3.99-14.18h-.29l-3.99,14.18h-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1196.31,475.24c-1.94,0-3.6-.42-4.99-1.25-1.39-.83-2.47-2-3.22-3.52-.75-1.51-1.13-3.29-1.13-5.32s.38-3.78,1.13-5.32c.75-1.53,1.81-2.73,3.17-3.59,1.36-.86,2.95-1.29,4.77-1.29,1.11,0,2.18.18,3.22.55,1.04.37,1.97.94,2.8,1.73.83.78,1.48,1.8,1.96,3.05.48,1.25.71,2.76.71,4.54v1.35h-15.61v-2.86h11.86c0-1.01-.2-1.9-.61-2.68-.41-.78-.98-1.4-1.72-1.85-.74-.45-1.6-.68-2.59-.68-1.07,0-2.01.26-2.8.79-.8.52-1.41,1.21-1.84,2.05-.43.84-.65,1.75-.65,2.73v2.24c0,1.31.23,2.43.7,3.35.46.92,1.12,1.62,1.95,2.1s1.81.72,2.93.72c.72,0,1.39-.1,1.98-.31.6-.21,1.11-.52,1.55-.94.43-.42.77-.93,1-1.55l3.62.65c-.29,1.07-.81,2-1.55,2.79-.75.8-1.68,1.42-2.8,1.85-1.12.44-2.4.66-3.83.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1208.99,474.85v-19.64h3.69v3.12h.21c.36-1.06.99-1.89,1.9-2.5s1.94-.91,3.09-.91c.24,0,.52,0,.85.03.33.02.59.04.77.06v3.66c-.15-.04-.43-.09-.82-.15-.39-.05-.78-.08-1.18-.08-.9,0-1.71.19-2.41.57s-1.26.9-1.67,1.57c-.41.67-.61,1.43-.61,2.28v11.99h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1224.75,452.18c-.67,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1235.61,463.19v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84s1.79,1.39,2.34,2.49c.55,1.1.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.06-1.21-.89,0-1.67.19-2.36.58-.69.38-1.23.94-1.62,1.68-.4.74-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1261.52,482.62c-1.56,0-2.9-.2-4.02-.61-1.12-.41-2.03-.95-2.74-1.62-.71-.67-1.24-1.41-1.58-2.21l3.29-1.36c.23.38.54.77.93,1.2s.92.78,1.58,1.08c.67.3,1.53.45,2.59.45,1.45,0,2.65-.35,3.59-1.05.95-.7,1.42-1.82,1.42-3.36v-3.86h-.24c-.23.42-.56.88-.99,1.39-.43.51-1.02.96-1.77,1.33s-1.73.56-2.93.56c-1.55,0-2.95-.36-4.19-1.09-1.24-.73-2.22-1.81-2.94-3.23-.72-1.43-1.08-3.19-1.08-5.27s.36-3.88,1.07-5.37c.71-1.49,1.69-2.63,2.93-3.43s2.65-1.2,4.23-1.2c1.22,0,2.2.2,2.95.61.75.41,1.34.88,1.76,1.41s.75,1.01.98,1.42h.28v-3.18h3.75v20.07c0,1.69-.39,3.07-1.18,4.16-.79,1.08-1.84,1.88-3.18,2.4-1.33.52-2.84.78-4.51.78Zm-.04-11.24c1.1,0,2.03-.26,2.79-.77s1.34-1.26,1.74-2.22c.4-.97.59-2.13.59-3.48s-.2-2.48-.59-3.49c-.39-1-.97-1.79-1.73-2.36-.76-.57-1.7-.85-2.81-.85s-2.11.3-2.88.89c-.77.59-1.34,1.4-1.73,2.41-.39,1.01-.58,2.15-.58,3.4s.2,2.42.59,3.39c.39.97.97,1.73,1.74,2.28.77.54,1.72.82,2.86.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1285.35,474.85v-26.18h3.95v22.78h11.86v3.4h-15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1307.29,452.18c-.67,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1322.55,482.62c-1.56,0-2.9-.2-4.02-.61-1.12-.41-2.04-.95-2.74-1.62-.71-.67-1.24-1.41-1.59-2.21l3.29-1.36c.23.38.54.77.93,1.2.39.42.92.78,1.58,1.08.67.3,1.53.45,2.59.45,1.45,0,2.65-.35,3.59-1.05.95-.7,1.42-1.82,1.42-3.36v-3.86h-.24c-.23.42-.56.88-.99,1.39-.43.51-1.02.96-1.77,1.33-.75.38-1.73.56-2.93.56-1.55,0-2.95-.36-4.19-1.09-1.24-.73-2.22-1.81-2.94-3.23-.72-1.43-1.08-3.19-1.08-5.27s.36-3.88,1.07-5.37c.71-1.49,1.69-2.63,2.93-3.43,1.25-.8,2.66-1.2,4.23-1.2,1.22,0,2.2.2,2.95.61.75.41,1.34.88,1.76,1.41s.75,1.01.98,1.42h.28v-3.18h3.75v20.07c0,1.69-.39,3.07-1.18,4.16-.78,1.08-1.84,1.88-3.18,2.4-1.33.52-2.84.78-4.51.78Zm-.04-11.24c1.1,0,2.03-.26,2.79-.77s1.34-1.26,1.74-2.22c.4-.97.59-2.13.59-3.48s-.2-2.48-.59-3.49c-.39-1-.97-1.79-1.73-2.36-.76-.57-1.7-.85-2.81-.85s-2.11.3-2.88.89c-.77.59-1.34,1.4-1.73,2.41-.39,1.01-.58,2.15-.58,3.4s.2,2.42.59,3.39.97,1.73,1.75,2.28c.77.54,1.72.82,2.86.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1340.36,463.19v11.66h-3.82v-26.18h3.77v9.74h.24c.46-1.06,1.16-1.9,2.11-2.52s2.18-.93,3.71-.93c1.35,0,2.52.28,3.54.83,1.01.55,1.79,1.38,2.35,2.47.56,1.09.84,2.46.84,4.1v12.49h-3.82v-12.03c0-1.44-.37-2.56-1.11-3.36-.74-.8-1.77-1.2-3.09-1.2-.9,0-1.71.19-2.42.58s-1.27.94-1.67,1.68-.61,1.62-.61,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1367.37,455.21v3.07h-10.73v-3.07h10.73Zm-7.85-4.7h3.82v18.58c0,.74.11,1.3.33,1.67.22.37.51.62.86.75s.74.2,1.16.2c.31,0,.58-.02.81-.06.23-.04.41-.08.54-.1l.69,3.16c-.22.08-.54.17-.95.26-.41.09-.92.14-1.54.15-1.01.02-1.94-.16-2.81-.54s-1.57-.95-2.11-1.74-.8-1.77-.8-2.95v-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1375.41,463.19v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84,1,.56,1.79,1.39,2.34,2.49s.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.05-1.21-.89,0-1.67.19-2.36.58-.69.38-1.23.94-1.62,1.68s-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1395.02,452.18c-.67,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1405.88,463.19v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84s1.79,1.39,2.34,2.49c.55,1.1.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.06-1.21-.89,0-1.67.19-2.36.58-.69.38-1.23.94-1.62,1.68-.4.74-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1431.79,482.62c-1.56,0-2.9-.2-4.02-.61-1.12-.41-2.03-.95-2.74-1.62-.71-.67-1.24-1.41-1.58-2.21l3.29-1.36c.23.38.54.77.93,1.2s.92.78,1.58,1.08c.67.3,1.53.45,2.59.45,1.45,0,2.65-.35,3.59-1.05.95-.7,1.42-1.82,1.42-3.36v-3.86h-.24c-.23.42-.56.88-.99,1.39-.43.51-1.02.96-1.77,1.33s-1.73.56-2.93.56c-1.55,0-2.95-.36-4.19-1.09-1.24-.73-2.22-1.81-2.94-3.23-.72-1.43-1.08-3.19-1.08-5.27s.36-3.88,1.07-5.37c.71-1.49,1.69-2.63,2.93-3.43s2.65-1.2,4.23-1.2c1.22,0,2.2.2,2.95.61.75.41,1.34.88,1.76,1.41s.75,1.01.98,1.42h.28v-3.18h3.75v20.07c0,1.69-.39,3.07-1.18,4.16-.79,1.08-1.84,1.88-3.18,2.4-1.33.52-2.84.78-4.51.78Zm-.04-11.24c1.1,0,2.03-.26,2.79-.77s1.34-1.26,1.74-2.22c.4-.97.59-2.13.59-3.48s-.2-2.48-.59-3.49c-.39-1-.97-1.79-1.73-2.36-.76-.57-1.7-.85-2.81-.85s-2.11.3-2.88.89c-.77.59-1.34,1.4-1.73,2.41-.39,1.01-.58,2.15-.58,3.4s.2,2.42.59,3.39c.39.97.97,1.73,1.74,2.28.77.54,1.72.82,2.86.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1457.35,462.13v3.31h-11.61v-3.31h11.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1462.75,474.85v-26.18h16.24v3.4h-12.29v7.98h11.12v3.39h-11.12v11.42h-3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1489.18,475.28c-1.24,0-2.37-.23-3.38-.7-1.01-.46-1.8-1.14-2.38-2.03-.58-.89-.88-1.97-.88-3.26,0-1.11.21-2.02.64-2.74.43-.72,1-1.28,1.73-1.7s1.53-.73,2.43-.95c.89-.21,1.81-.38,2.74-.49,1.18-.14,2.13-.25,2.86-.34s1.27-.24,1.6-.44c.33-.2.5-.54.5-1v-.09c0-1.12-.31-1.98-.94-2.6s-1.56-.92-2.79-.92-2.3.28-3.04.85c-.74.57-1.25,1.2-1.53,1.89l-3.59-.82c.43-1.19,1.05-2.16,1.87-2.9.82-.74,1.77-1.27,2.84-1.61,1.07-.34,2.2-.5,3.39-.5.78,0,1.62.09,2.5.27.88.18,1.71.52,2.48,1,.77.49,1.4,1.18,1.9,2.08s.74,2.06.74,3.5v13.04h-3.73v-2.68h-.15c-.25.49-.62.98-1.11,1.46-.5.48-1.13.87-1.91,1.19s-1.71.47-2.79.47Zm.83-3.07c1.06,0,1.96-.21,2.72-.63.75-.42,1.33-.97,1.73-1.64.4-.68.59-1.4.59-2.18v-2.53c-.14.14-.4.26-.79.38s-.83.21-1.32.29-.98.15-1.44.22c-.47.06-.86.12-1.18.16-.74.09-1.42.25-2.03.47-.61.22-1.09.54-1.46.95s-.54.96-.54,1.64c0,.95.35,1.66,1.05,2.14.7.48,1.59.72,2.67.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1518.67,460l-3.46.61c-.15-.44-.37-.87-.68-1.27s-.73-.73-1.26-.98c-.53-.26-1.19-.38-1.98-.38-1.08,0-1.99.24-2.71.72s-1.09,1.1-1.09,1.86c0,.66.24,1.19.73,1.59.49.4,1.27.73,2.35.98l3.12.72c1.81.42,3.15,1.06,4.04,1.93.89.87,1.33,2,1.33,3.39,0,1.18-.34,2.22-1.02,3.14-.68.92-1.62,1.63-2.83,2.15-1.21.52-2.6.78-4.19.78-2.2,0-3.99-.47-5.38-1.41-1.39-.94-2.24-2.28-2.56-4.02l3.69-.56c.23.96.7,1.69,1.42,2.18.71.49,1.65.74,2.8.74,1.25,0,2.25-.26,3-.79s1.12-1.17,1.12-1.92c0-.61-.23-1.13-.68-1.55-.46-.42-1.15-.73-2.09-.95l-3.32-.73c-1.83-.42-3.19-1.08-4.06-1.99-.87-.91-1.31-2.07-1.31-3.46,0-1.16.32-2.17.97-3.04s1.54-1.55,2.68-2.04c1.14-.49,2.45-.73,3.92-.73,2.12,0,3.79.46,5.01,1.37,1.22.92,2.02,2.14,2.42,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1532.41,455.21v3.07h-10.73v-3.07h10.73Zm-7.85-4.7h3.82v18.58c0,.74.11,1.3.33,1.67.22.37.51.62.86.75s.74.2,1.16.2c.31,0,.58-.02.8-.06.23-.04.41-.08.54-.1l.69,3.16c-.22.08-.54.17-.95.26-.41.09-.92.14-1.53.15-1.01.02-1.94-.16-2.81-.54-.87-.38-1.57-.95-2.11-1.74-.54-.78-.8-1.77-.8-2.95v-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1554.95,474.85h-8.48v-26.18h8.75c2.56,0,4.77.52,6.61,1.57,1.84,1.04,3.25,2.54,4.24,4.49.98,1.95,1.48,4.28,1.48,7s-.5,5.07-1.49,7.03c-.99,1.96-2.43,3.47-4.3,4.52-1.88,1.05-4.14,1.58-6.8,1.58Zm-4.53-3.45h4.31c1.99,0,3.65-.38,4.97-1.13,1.32-.75,2.31-1.85,2.97-3.29.66-1.44.98-3.19.98-5.26s-.33-3.8-.98-5.23c-.65-1.43-1.62-2.52-2.91-3.26-1.29-.74-2.88-1.11-4.79-1.11h-4.55v19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1574.08,452.18c-.67,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1589.34,482.62c-1.56,0-2.9-.2-4.02-.61-1.12-.41-2.04-.95-2.74-1.62-.71-.67-1.24-1.41-1.59-2.21l3.29-1.36c.23.38.54.77.93,1.2s.92.78,1.58,1.08c.67.3,1.53.45,2.59.45,1.45,0,2.65-.35,3.59-1.05.95-.7,1.42-1.82,1.42-3.36v-3.86h-.24c-.23.42-.56.88-.99,1.39-.43.51-1.02.96-1.77,1.33s-1.73.56-2.93.56c-1.55,0-2.95-.36-4.19-1.09-1.24-.73-2.22-1.81-2.94-3.23-.72-1.43-1.08-3.19-1.08-5.27s.36-3.88,1.07-5.37c.71-1.49,1.69-2.63,2.93-3.43,1.24-.8,2.65-1.2,4.23-1.2,1.22,0,2.2.2,2.95.61.75.41,1.34.88,1.76,1.41s.75,1.01.98,1.42h.28v-3.18h3.75v20.07c0,1.69-.39,3.07-1.18,4.16-.78,1.08-1.84,1.88-3.18,2.4-1.33.52-2.84.78-4.51.78Zm-.04-11.24c1.1,0,2.03-.26,2.79-.77s1.34-1.26,1.74-2.22c.4-.97.59-2.13.59-3.48s-.2-2.48-.59-3.49c-.39-1-.97-1.79-1.73-2.36-.76-.57-1.7-.85-2.81-.85s-2.11.3-2.88.89c-.77.59-1.34,1.4-1.73,2.41-.39,1.01-.58,2.15-.58,3.4s.2,2.42.59,3.39c.39.97.97,1.73,1.75,2.28.77.54,1.72.82,2.86.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1605.26,452.18c-.67,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1621.46,455.21v3.07h-10.73v-3.07h10.73Zm-7.85-4.7h3.82v18.58c0,.74.11,1.3.33,1.67.22.37.51.62.86.75s.74.2,1.16.2c.31,0,.58-.02.8-.06.23-.04.41-.08.54-.1l.69,3.16c-.22.08-.54.17-.95.26-.41.09-.92.14-1.53.15-1.01.02-1.94-.16-2.81-.54-.87-.38-1.57-.95-2.11-1.74-.54-.78-.8-1.77-.8-2.95v-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1631.39,475.28c-1.24,0-2.37-.23-3.38-.7-1.01-.46-1.8-1.14-2.38-2.03-.58-.89-.88-1.97-.88-3.26,0-1.11.21-2.02.64-2.74.43-.72,1-1.28,1.73-1.7.72-.42,1.53-.73,2.43-.95.89-.21,1.81-.38,2.74-.49,1.18-.14,2.13-.25,2.86-.34.73-.09,1.27-.24,1.6-.44.33-.2.5-.54.5-1v-.09c0-1.12-.31-1.98-.94-2.6-.63-.61-1.56-.92-2.79-.92s-2.3.28-3.04.85c-.74.57-1.25,1.2-1.53,1.89l-3.59-.82c.43-1.19,1.05-2.16,1.87-2.9s1.77-1.27,2.84-1.61c1.07-.34,2.2-.5,3.39-.5.78,0,1.62.09,2.5.27s1.71.52,2.48,1c.77.49,1.4,1.18,1.9,2.08.49.9.74,2.06.74,3.5v13.04h-3.73v-2.68h-.15c-.25.49-.62.98-1.11,1.46-.49.48-1.13.87-1.9,1.19-.78.32-1.71.47-2.79.47Zm.83-3.07c1.06,0,1.96-.21,2.72-.63.75-.42,1.33-.97,1.73-1.64.4-.68.59-1.4.59-2.18v-2.53c-.14.14-.4.26-.79.38-.39.12-.83.21-1.32.29-.5.08-.98.15-1.45.22-.47.06-.86.12-1.18.16-.74.09-1.42.25-2.03.47-.61.22-1.09.54-1.46.95s-.54.96-.54,1.64c0,.95.35,1.66,1.05,2.14.7.48,1.59.72,2.67.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1649.99,448.67v26.18h-3.82v-26.18h3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1673.45,474.85h-8.48v-26.18h8.75c2.56,0,4.77.52,6.61,1.57,1.84,1.04,3.25,2.54,4.24,4.49.98,1.95,1.48,4.28,1.48,7s-.5,5.07-1.49,7.03c-.99,1.96-2.43,3.47-4.3,4.52-1.88,1.05-4.14,1.58-6.8,1.58Zm-4.53-3.45h4.31c1.99,0,3.65-.38,4.97-1.13,1.32-.75,2.31-1.85,2.97-3.29.66-1.44.98-3.19.98-5.26s-.33-3.8-.98-5.23c-.65-1.43-1.62-2.52-2.91-3.26-1.29-.74-2.88-1.11-4.79-1.11h-4.55v19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1699.11,475.24c-1.93,0-3.6-.42-4.99-1.25-1.39-.83-2.47-2-3.22-3.52-.75-1.51-1.13-3.29-1.13-5.32s.38-3.78,1.13-5.32c.75-1.53,1.81-2.73,3.17-3.59,1.36-.86,2.95-1.29,4.78-1.29,1.11,0,2.18.18,3.22.55,1.04.37,1.97.94,2.8,1.73.83.78,1.48,1.8,1.96,3.05s.72,2.76.72,4.54v1.35h-15.61v-2.86h11.86c0-1.01-.21-1.9-.61-2.68-.41-.78-.98-1.4-1.72-1.85-.74-.45-1.6-.68-2.59-.68-1.07,0-2.01.26-2.81.79s-1.41,1.21-1.84,2.05c-.43.84-.65,1.75-.65,2.73v2.24c0,1.31.23,2.43.7,3.35.46.92,1.11,1.62,1.95,2.1s1.81.72,2.93.72c.72,0,1.38-.1,1.98-.31s1.11-.52,1.55-.94c.43-.42.77-.93,1-1.55l3.62.65c-.29,1.07-.81,2-1.55,2.79-.75.8-1.68,1.42-2.8,1.85-1.12.44-2.4.66-3.83.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1726.5,460l-3.46.61c-.14-.44-.37-.87-.68-1.27-.31-.4-.73-.73-1.26-.98s-1.19-.38-1.98-.38c-1.08,0-1.99.24-2.71.72s-1.09,1.1-1.09,1.86c0,.66.24,1.19.73,1.59.49.4,1.27.73,2.35.98l3.12.72c1.81.42,3.15,1.06,4.04,1.93.89.87,1.33,2,1.33,3.39,0,1.18-.34,2.22-1.02,3.14-.68.92-1.62,1.63-2.83,2.15-1.21.52-2.6.78-4.19.78-2.2,0-3.99-.47-5.38-1.41-1.39-.94-2.24-2.28-2.56-4.02l3.69-.56c.23.96.7,1.69,1.42,2.18.72.49,1.65.74,2.8.74,1.25,0,2.25-.26,3-.79s1.12-1.17,1.12-1.92c0-.61-.23-1.13-.68-1.55-.46-.42-1.15-.73-2.09-.95l-3.32-.73c-1.83-.42-3.19-1.08-4.06-1.99-.87-.91-1.31-2.07-1.31-3.46,0-1.16.32-2.17.97-3.04s1.54-1.55,2.68-2.04c1.14-.49,2.45-.73,3.92-.73,2.12,0,3.79.46,5.01,1.37s2.02,2.14,2.42,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1740.25,455.21v3.07h-10.73v-3.07h10.73Zm-7.85-4.7h3.82v18.58c0,.74.11,1.3.33,1.67.22.37.51.62.86.75s.74.2,1.16.2c.31,0,.58-.02.8-.06.23-.04.41-.08.54-.1l.69,3.16c-.22.08-.54.17-.95.26-.41.09-.92.14-1.53.15-1.01.02-1.94-.16-2.81-.54-.87-.38-1.57-.95-2.11-1.74-.54-.78-.8-1.77-.8-2.95v-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1746.39,452.18c-.67,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1757.25,463.19v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84s1.79,1.39,2.34,2.49.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.06-1.21-.89,0-1.67.19-2.36.58-.69.38-1.23.94-1.62,1.68s-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1780.64,475.28c-1.24,0-2.37-.23-3.38-.7-1.01-.46-1.8-1.14-2.38-2.03-.58-.89-.88-1.97-.88-3.26,0-1.11.21-2.02.64-2.74.43-.72,1-1.28,1.73-1.7.72-.42,1.53-.73,2.43-.95.89-.21,1.81-.38,2.74-.49,1.18-.14,2.13-.25,2.86-.34.73-.09,1.27-.24,1.6-.44.33-.2.5-.54.5-1v-.09c0-1.12-.31-1.98-.94-2.6-.63-.61-1.56-.92-2.79-.92s-2.3.28-3.04.85c-.74.57-1.25,1.2-1.53,1.89l-3.59-.82c.43-1.19,1.05-2.16,1.87-2.9s1.77-1.27,2.84-1.61c1.07-.34,2.2-.5,3.39-.5.78,0,1.62.09,2.5.27s1.71.52,2.48,1c.77.49,1.4,1.18,1.9,2.08.49.9.74,2.06.74,3.5v13.04h-3.73v-2.68h-.15c-.25.49-.62.98-1.11,1.46-.49.48-1.13.87-1.9,1.19-.78.32-1.71.47-2.79.47Zm.83-3.07c1.06,0,1.96-.21,2.72-.63.75-.42,1.33-.97,1.73-1.64.4-.68.59-1.4.59-2.18v-2.53c-.14.14-.4.26-.79.38-.39.12-.83.21-1.32.29-.5.08-.98.15-1.45.22-.47.06-.86.12-1.18.16-.74.09-1.42.25-2.03.47-.61.22-1.09.54-1.46.95s-.54.96-.54,1.64c0,.95.35,1.66,1.05,2.14.7.48,1.59.72,2.67.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1804.59,455.21v3.07h-10.73v-3.07h10.73Zm-7.85-4.7h3.82v18.58c0,.74.11,1.3.33,1.67.22.37.51.62.86.75s.74.2,1.16.2c.31,0,.58-.02.8-.06.23-.04.41-.08.54-.1l.69,3.16c-.22.08-.54.17-.95.26-.41.09-.92.14-1.53.15-1.01.02-1.94-.16-2.81-.54-.87-.38-1.57-.95-2.11-1.74-.54-.78-.8-1.77-.8-2.95v-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1810.74,452.18c-.67,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1826.04,475.24c-1.84,0-3.45-.42-4.82-1.27s-2.44-2.02-3.2-3.54c-.76-1.52-1.14-3.29-1.14-5.32s.38-3.82,1.14-5.34,1.82-2.71,3.2-3.55,2.98-1.27,4.82-1.27,3.45.42,4.82,1.27,2.44,2.03,3.2,3.55,1.14,3.31,1.14,5.34-.38,3.8-1.14,5.32c-.76,1.52-1.82,2.7-3.2,3.54s-2.98,1.27-4.82,1.27Zm.01-3.21c1.19,0,2.18-.32,2.97-.95.78-.63,1.37-1.47,1.75-2.52.38-1.05.57-2.2.57-3.46s-.19-2.41-.57-3.46-.96-1.9-1.75-2.54c-.78-.64-1.77-.96-2.97-.96s-2.2.32-2.99.96c-.79.64-1.37,1.49-1.75,2.54s-.57,2.21-.57,3.46.19,2.42.57,3.46c.38,1.05.96,1.89,1.75,2.52.79.63,1.78.95,2.99.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1843.27,463.19v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84s1.79,1.39,2.34,2.49.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.06-1.21-.89,0-1.67.19-2.36.58-.69.38-1.23.94-1.62,1.68s-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1875.67,460l-3.46.61c-.14-.44-.37-.87-.68-1.27-.31-.4-.73-.73-1.26-.98s-1.19-.38-1.98-.38c-1.08,0-1.99.24-2.71.72s-1.09,1.1-1.09,1.86c0,.66.24,1.19.73,1.59.49.4,1.27.73,2.35.98l3.12.72c1.81.42,3.15,1.06,4.04,1.93.89.87,1.33,2,1.33,3.39,0,1.18-.34,2.22-1.02,3.14-.68.92-1.62,1.63-2.83,2.15-1.21.52-2.6.78-4.19.78-2.2,0-3.99-.47-5.38-1.41-1.39-.94-2.24-2.28-2.56-4.02l3.69-.56c.23.96.7,1.69,1.42,2.18.72.49,1.65.74,2.8.74,1.25,0,2.25-.26,3-.79s1.12-1.17,1.12-1.92c0-.61-.23-1.13-.68-1.55-.46-.42-1.15-.73-2.09-.95l-3.32-.73c-1.83-.42-3.19-1.08-4.06-1.99-.87-.91-1.31-2.07-1.31-3.46,0-1.16.32-2.17.97-3.04s1.54-1.55,2.68-2.04c1.14-.49,2.45-.73,3.92-.73,2.12,0,3.79.46,5.01,1.37s2.02,2.14,2.42,3.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1445,
    y: 305.75,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m1518.93,331.87v37.2h-47.85v-37.2h47.85m5.24-5.24h-58.33v47.68h58.33v-47.68h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1504.24,
    y: 337.56,
    width: 5.24,
    height: 17.29,
    transform: "translate(196.54 1166.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1498.21,
    y: 352.11,
    width: 17.29,
    height: 5.24,
    transform: "translate(190.52 1169.41) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1480.52,
    y: 346.08,
    width: 5.24,
    height: 17.29,
    transform: "translate(183.57 1152.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1474.5,
    y: 343.59,
    width: 17.29,
    height: 5.24,
    transform: "translate(189.6 1150.14) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1487.05,
    y: 374.4,
    width: 15.89,
    height: 5.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "1514.91 379.64 1475.09 379.64 1470.09 384.88 1519.91 384.88 1514.91 379.64"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m685.7,689.21c0,5.64-110.12,10.15-245.95,10.06-135.83-.09-245.94-4.73-245.94-10.38,0-5.64,110.12-10.15,245.95-10.06,135.83.09,245.94,4.73,245.94,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m908.15,701.68c0,5.64-110.12,10.15-245.95,10.06-135.83-.09-245.94-4.73-245.94-10.38,0-5.64,110.12-10.14,245.95-10.06,135.83.09,245.94,4.73,245.94,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1080.6,709.46c0,5.64-69.18,10.17-154.5,10.12-85.32-.06-154.49-4.68-154.49-10.32,0-5.64,69.18-10.17,154.5-10.12,85.32.06,154.49,4.67,154.49,10.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m443.02,557.82v127.76h106.41v-127.76h-106.41Zm78.1,57.82c0,11.78-9.55,21.34-21.34,21.34h-7.11c-11.79,0-21.34-9.56-21.34-21.34v-23.11c0-11.78,9.55-21.34,21.34-21.34h7.11c11.79,0,21.34,9.56,21.34,21.34v23.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "635.03 691.06 357.42 691.06 368.82 680.1 623.63 680.1 635.03 691.06"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m810.45,230.01c0-10.42-8.45-18.87-18.87-18.87H200.87c-10.42,0-18.87,8.45-18.87,18.87v324.91h628.45V230.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m182,554.93v30.53c0,10.42,8.45,18.87,18.87,18.87h590.71c10.42,0,18.87-8.45,18.87-18.87v-30.53H182Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m200.15,554.93V229.16c0-.4.33-.73.72-.73h590.71c.4,0,.73.33.73.73v325.77H200.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m791.58,228.43h-259.35l-92.48,326.5h352.56V229.16c0-.4-.32-.73-.73-.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-63",
    transform: "translate(364.61 256.64)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "Home       "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 37.27,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 41.5,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 46.15,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 50.58,
    y: 0
  }, "tu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 58.76,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 61.7,
    y: 0,
    xmlSpace: "preserve"
  }, "es       "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 83.77,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 88.47,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 93.56,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 96.82,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 99.83,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 104.92,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 107.51,
    y: 0
  }, "olio"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 122.05,
    y: 0,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 140.39,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 146.04,
    y: 0
  }, "bout "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 166.55,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 172.49,
    y: 0,
    xmlSpace: "preserve"
  }, "s       "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 189.92,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 195.2,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 200.29,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 205.4,
    y: 0
  }, "ta"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 212.94,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 217.21,
    y: 0
  }, "t "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 222.25,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 228.19,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 217.95,
    y1: 248.11,
    x2: 235.96,
    y2: 248.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 217.95,
    y1: 253.08,
    x2: 235.96,
    y2: 253.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 217.95,
    y1: 258.05,
    x2: 235.96,
    y2: 258.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m773.29,252.75c0,1.46-1.18,2.64-2.64,2.64s-2.64-1.18-2.64-2.64,1.18-2.64,2.64-2.64,2.64,1.18,2.64,2.64Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 772.58,
    y1: 254.67,
    x2: 774.5,
    y2: 256.59
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 768.02,
    y1: 261.02,
    x2: 682.27,
    y2: 261.02
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m589.5,509.06c4.55,0,8.23-3.68,8.23-8.23s-3.68-8.24-8.23-8.24h-60.63c-4.55,0-8.24,3.69-8.24,8.24s3.69,8.23,8.24,8.23h60.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m586.05,500.83c0,2.11,1.72,3.83,3.84,3.83s3.83-1.72,3.83-3.83-1.72-3.84-3.83-3.84-3.84,1.72-3.84,3.84Zm5.5,0l-2.06,2.06-.58-.58,1.48-1.48-1.48-1.48.58-.58,2.06,2.06Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-55",
    transform: "translate(528.19 502.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 3.39,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 5.28,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 8.51,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.86,
    y: 0
  }, "se "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-96",
    x: 19.47,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.82,
    y: 0
  }, "y c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 29.56,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 32.41,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.34,
    y: 0
  }, "ego"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 43.93,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.03,
    y: 0
  }, "y"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-66",
    transform: "translate(520.64 364.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-48",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 15.24,
    y: 0
  }, "esponsive"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-122",
    x: 0,
    y: 29.81
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.91,
    y: 29.81
  }, "ebsite Design")), /*#__PURE__*/React.createElement("text", {
    className: "cls-62",
    transform: "translate(520.64 412.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 0,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.73,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 6,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.89,
    y: 0
  }, "em ipsum dolor sit ame"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 66.11,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.06,
    y: 0
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 70.56,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.2,
    y: 0
  }, "onse"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-119",
    x: 85.12,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 87.87,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 89.8,
    y: 0
  }, "etuer adipiscing eli"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 136.77,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 138.72,
    y: 0
  }, ", sed diam nonum"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 183.19,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 188.08,
    y: 0
  }, "y nibh euismod "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9.93
  }, "tincidu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 17.38,
    y: 9.93
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.67,
    y: 9.93
  }, "t ut lao"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 37.97,
    y: 9.93
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.86,
    y: 9.93
  }, "eet dolo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 60.38,
    y: 9.93
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.27,
    y: 9.93
  }, "e ma"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 74.36,
    y: 9.93
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.65,
    y: 9.93
  }, "na aliquam e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-105",
    x: 109.5,
    y: 9.93
  }, "ra"), /*#__PURE__*/React.createElement("tspan", {
    x: 114.27,
    y: 9.93
  }, "t "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 117.5,
    y: 9.93
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 120.31,
    y: 9.93
  }, "olutp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 133.63,
    y: 9.93
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 136.48,
    y: 9.93
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 138.44,
    y: 9.93
  }, ". "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 140.93,
    y: 9.93
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 144.81,
    y: 9.93
  }, "t wisi enim ad minim "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 197.56,
    y: 9.93
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 200.37,
    y: 9.93
  }, "eniam, quis "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19.86
  }, "nostrud "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 20.77,
    y: 19.86
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-104",
    x: 23.74,
    y: 19.86
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.4,
    y: 19.86
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 29.39,
    y: 19.86
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.28,
    y: 19.86
  }, "ci t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 38.58,
    y: 19.86
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.43,
    y: 19.86
  }, "tion ullam"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 66.58,
    y: 19.86
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.21,
    y: 19.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-126",
    x: 72.48,
    y: 19.86
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.45,
    y: 19.86
  }, "per suscipit lobo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-82",
    x: 115.47,
    y: 19.86
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 117.56,
    y: 19.86
  }, "tis nisl ut "))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 520.63,
    y: 457.13,
    width: 152.27,
    height: 13.6
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-55",
    transform: "translate(527.7 466.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "wh"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 7.69,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.54,
    y: 0
  }, "t do "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 21.67,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.42,
    y: 0
  }, "ou need?")), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m660.74,463.93c0,2.24,1.82,4.05,4.06,4.05s4.06-1.81,4.06-4.05-1.82-4.06-4.06-4.06-4.06,1.81-4.06,4.06Zm5.82,0l-2.18,2.18-.62-.62,1.57-1.56-1.57-1.57.62-.62,2.18,2.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "286.55 418.71 256.81 424.7 242.65 474.57 247.73 477.62 271.54 452.45 286.55 418.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "271.54 452.45 286.55 418.71 259.93 464.73 271.54 452.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "326.92 459.08 320.93 488.82 271.06 502.97 268.01 497.89 293.18 474.08 326.92 459.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "293.18 474.08 326.92 459.08 280.9 485.69 293.18 474.08"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m271.52,452.43l10.84,10.84,10.84,10.84s8.37-2.36,21.71-8.77l-34.62-34.62c-6.42,13.35-8.77,21.71-8.77,21.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m357.87,338.86c-13.37,8.01-27.62,20.08-42.32,37.69-17.48,20.94-28.58,40.25-35.26,54.16l34.62,34.62c13.91-6.69,33.22-17.78,54.16-35.26,17.61-14.7,29.68-28.95,37.69-42.32-8.7-6.69-17.46-14.36-26-22.9-8.54-8.54-16.2-17.3-22.9-25.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m418.71,326.92c-15.72-3.67-36.85-2.42-60.84,11.95,6.69,8.7,14.36,17.45,22.9,25.99,8.54,8.54,17.3,16.2,26,22.9,14.37-23.98,15.61-45.12,11.95-60.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m373.54,405.28c-9.17,9.17-24.03,9.17-33.2,0-9.17-9.16-9.17-24.03,0-33.2,9.17-9.17,24.03-9.17,33.2,0,9.17,9.17,9.17,24.03,0,33.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m370.32,402.06c-7.39,7.39-19.37,7.39-26.76,0-7.39-7.39-7.39-19.37,0-26.76,7.39-7.39,19.37-7.39,26.76,0,7.39,7.39,7.39,19.37,0,26.76Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m585.26,703.63c-10.49,0-19.08-8.59-19.08-19.08v-233.28c0-10.49,8.59-19.08,19.08-19.08h343.76c10.49,0,19.08,8.59,19.08,19.08v233.28c0,10.49-8.59,19.08-19.08,19.08h-343.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m585.25,446.63h343.76c2.56,0,4.63,2.08,4.63,4.63v233.28c0,2.56-2.08,4.64-4.64,4.64h-343.76c-2.56,0-4.64-2.08-4.64-4.64v-233.28c0-2.56,2.08-4.63,4.63-4.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "638.06 584.19 620.27 587.77 611.81 617.6 614.84 619.43 629.09 604.37 638.06 584.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "629.09 604.37 638.06 584.19 622.14 611.71 629.09 604.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "662.21 608.34 658.63 626.12 628.8 634.59 626.97 631.55 642.03 617.31 662.21 608.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "642.03 617.31 662.21 608.34 634.68 624.26 642.03 617.31"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m629.07,604.36l6.49,6.48,6.48,6.49s5-1.41,12.99-5.25l-20.71-20.71c-3.84,7.98-5.25,12.99-5.25,12.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m680.72,536.43c-8,4.79-16.52,12.01-25.31,22.54-10.45,12.53-17.09,24.08-21.09,32.4l20.71,20.71c8.32-4,19.87-10.64,32.4-21.09,10.53-8.79,17.75-17.32,22.54-25.31-5.2-4-10.44-8.59-15.55-13.7-5.11-5.11-9.69-10.35-13.7-15.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m717.11,529.28c-9.4-2.19-22.04-1.45-36.39,7.15,4,5.2,8.59,10.44,13.7,15.55,5.11,5.11,10.35,9.69,15.55,13.7,8.59-14.35,9.34-26.99,7.14-36.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m690.1,576.15c-5.48,5.49-14.37,5.49-19.86,0-5.48-5.48-5.48-14.37,0-19.85,5.49-5.48,14.37-5.48,19.86,0,5.48,5.48,5.48,14.37,0,19.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m688.17,574.23c-4.42,4.42-11.59,4.42-16,0-4.42-4.42-4.42-11.59,0-16.01,4.42-4.42,11.59-4.42,16,0,4.42,4.42,4.42,11.59,0,16.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m929.02,446.63h-140.55l-68.7,242.55h209.26c2.51,0,4.63-2.12,4.63-4.64v-233.28c0-2.51-2.12-4.63-4.63-4.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-63",
    transform: "translate(679.77 470.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "Home       "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 21.91,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 24.39,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 27.12,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 29.73,
    y: 0
  }, "tu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 34.54,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 36.26,
    y: 0,
    xmlSpace: "preserve"
  }, "es       "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 49.24,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 52,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 55,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 56.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 58.68,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 61.67,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 63.19,
    y: 0
  }, "olio"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 71.74,
    y: 0,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 82.52,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 85.84,
    y: 0
  }, "bout "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 97.9,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 101.39,
    y: 0,
    xmlSpace: "preserve"
  }, "s       "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 111.64,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 114.74,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 117.73,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 120.73,
    y: 0
  }, "ta"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 125.16,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 127.68,
    y: 0
  }, "t "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 130.64,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 134.13,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 593.57,
    y1: 465.85,
    x2: 604.15,
    y2: 465.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 593.57,
    y1: 468.77,
    x2: 604.15,
    y2: 468.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 593.57,
    y1: 471.69,
    x2: 604.15,
    y2: 471.69
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m920,468.57c0,.86-.69,1.55-1.55,1.55s-1.55-.69-1.55-1.55.69-1.55,1.55-1.55,1.55.7,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 919.57,
    y1: 469.7,
    x2: 920.71,
    y2: 470.83
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 916.9,
    y1: 473.44,
    x2: 866.49,
    y2: 473.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m818.09,639.44c2.67,0,4.84-2.17,4.84-4.84s-2.17-4.84-4.84-4.84h-35.64c-2.67,0-4.84,2.17-4.84,4.84s2.17,4.84,4.84,4.84h35.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m816.07,634.6c0,1.24,1.01,2.25,2.25,2.25s2.26-1.01,2.26-2.25-1.01-2.25-2.26-2.25-2.25,1.01-2.25,2.25Zm3.23,0l-1.21,1.21-.34-.34.87-.87-.87-.87.34-.34,1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-56",
    transform: "translate(782.06 635.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 1.99,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 3.1,
    y: 0
  }, "ow"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 7.56,
    y: 0
  }, "se "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 11.44,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.41,
    y: 0
  }, "y c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 17.37,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 19.05,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.19,
    y: 0
  }, "ego"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 25.82,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.06,
    y: 0
  }, "y"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-64",
    transform: "translate(777.62 554.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.46,
    y: 0
  }, "esponsive"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-121",
    x: 0,
    y: 16
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.61,
    y: 16
  }, "ebsite Design")), /*#__PURE__*/React.createElement("text", {
    className: "cls-68",
    transform: "translate(777.62 582.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-87",
    x: 0,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.6,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 3.53,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.64,
    y: 0
  }, "em ipsum dolor sit ame"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-76",
    x: 38.85,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 40,
    y: 0
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 41.47,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.02,
    y: 0
  }, "onse"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 50.03,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 51.64,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.78,
    y: 0
  }, "etuer adipiscing eli"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-76",
    x: 80.38,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.53,
    y: 0
  }, ", sed diam nonum"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-99",
    x: 107.67,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.54,
    y: 0
  }, "y nibh euismod "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.84
  }, "tincidu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 10.22,
    y: 5.84
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.15,
    y: 5.84
  }, "t ut lao"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 22.32,
    y: 5.84
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.43,
    y: 5.84
  }, "eet dolo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 35.49,
    y: 5.84
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.6,
    y: 5.84
  }, "e ma"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 43.7,
    y: 5.84
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.64,
    y: 5.84
  }, "na aliquam e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 64.36,
    y: 5.84
  }, "ra"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.16,
    y: 5.84
  }, "t "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 69.06,
    y: 5.84
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.71,
    y: 5.84
  }, "olutp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 78.54,
    y: 5.84
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.36,
    y: 5.84
  }, ". "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 82.83,
    y: 5.84
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 85.11,
    y: 5.84
  }, "t wisi enim ad minim "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 116.11,
    y: 5.84
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 117.76,
    y: 5.84
  }, "eniam, quis "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11.67
  }, "nostrud "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-76",
    x: 12.21,
    y: 11.67
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-103",
    x: 13.95,
    y: 11.67
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.52,
    y: 11.67
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 17.27,
    y: 11.67
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.39,
    y: 11.67
  }, "ci t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 22.68,
    y: 11.67
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.35,
    y: 11.67
  }, "tion ullam"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 39.13,
    y: 11.67
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.68,
    y: 11.67
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 42.6,
    y: 11.67
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.76,
    y: 11.67
  }, "per suscipit lobo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 67.87,
    y: 11.67
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.1,
    y: 11.67
  }, "tis nisl ut "))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 777.61,
    y: 608.91,
    width: 89.5,
    height: 7.99
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-56",
    transform: "translate(781.77 614.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "wh"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 4.52,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.2,
    y: 0
  }, "t do "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 12.74,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.35,
    y: 0
  }, "ou need?")), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m859.97,612.91c0,1.32,1.07,2.38,2.38,2.38s2.39-1.07,2.39-2.38-1.07-2.38-2.39-2.38-2.38,1.07-2.38,2.38Zm3.42,0l-1.28,1.28-.36-.36.92-.92-.92-.92.36-.37,1.28,1.28Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "566.17 628.29 641.51 703.63 801.57 703.63 566.17 468.23 566.17 628.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "810.45 432.19 948.09 569.83 948.09 455.1 925.18 432.19 810.45 432.19"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m906.93,505.18h80.62c6.14,0,11.12,4.98,11.12,11.12v185.22c0,6.14-4.98,11.12-11.12,11.12h-80.63c-6.14,0-11.12-4.98-11.12-11.12v-185.22c0-6.14,4.98-11.12,11.12-11.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m995.2,516.3c0-4.21-3.43-7.65-7.64-7.65h-80.63c-4.21,0-7.64,3.43-7.64,7.65v98.78l95.91-12.4v-86.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m899.29,615.08v86.44c0,4.22,3.43,7.65,7.64,7.65h80.63c4.21,0,7.64-3.43,7.64-7.65v-98.84l-95.91,12.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "931.62 570.54 922.04 572.46 917.49 588.52 919.12 589.5 926.79 581.4 931.62 570.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "926.79 581.4 931.62 570.54 923.05 585.35 926.79 581.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "944.61 583.53 942.68 593.11 926.63 597.67 925.65 596.03 933.75 588.36 944.61 583.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "933.75 588.36 944.61 583.53 929.8 592.1 933.75 588.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m926.78,581.39l3.49,3.49,3.49,3.49s2.7-.76,6.99-2.83l-11.15-11.14c-2.07,4.3-2.83,6.99-2.83,6.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m954.58,544.83c-4.3,2.58-8.89,6.46-13.62,12.13-5.63,6.74-9.2,12.96-11.35,17.44l11.15,11.14c4.47-2.15,10.69-5.72,17.44-11.35,5.67-4.73,9.55-9.32,12.13-13.62-2.8-2.16-5.62-4.62-8.37-7.37-2.75-2.75-5.22-5.57-7.37-8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m974.16,540.99c-5.06-1.18-11.87-.78-19.59,3.85,2.16,2.8,4.62,5.62,7.37,8.37,2.75,2.75,5.57,5.22,8.37,7.37,4.63-7.72,5.03-14.53,3.85-19.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m959.62,566.22c-2.95,2.95-7.74,2.95-10.69,0-2.95-2.95-2.95-7.74,0-10.69,2.95-2.95,7.73-2.95,10.69,0,2.95,2.95,2.95,7.73,0,10.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m958.59,565.18c-2.38,2.38-6.24,2.38-8.61,0-2.38-2.38-2.38-6.23,0-8.61,2.38-2.38,6.24-2.38,8.61,0,2.38,2.38,2.38,6.24,0,8.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 904.09,
    y1: 518.93,
    x2: 911.13,
    y2: 518.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 904.09,
    y1: 520.87,
    x2: 911.13,
    y2: 520.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 904.09,
    y1: 522.81,
    x2: 911.13,
    y2: 522.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m989.93,520.74c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03.46-1.03,1.03-1.03,1.03.46,1.03,1.03Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 989.65,
    y1: 521.5,
    x2: 990.4,
    y2: 522.25
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 987.86,
    y1: 523.98,
    x2: 954.34,
    y2: 523.98
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m968.8,685.96c3.24,0,5.85-2.62,5.85-5.86s-2.62-5.86-5.85-5.86h-43.11c-3.24,0-5.86,2.63-5.86,5.86s2.62,5.86,5.86,5.86h43.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m966.36,680.11c0,1.51,1.22,2.73,2.72,2.73s2.73-1.22,2.73-2.73-1.22-2.73-2.73-2.73-2.72,1.22-2.72,2.73Zm3.91,0l-1.47,1.47-.41-.42,1.05-1.05-1.05-1.05.41-.41,1.47,1.46Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-57",
    transform: "translate(925.21 681.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-110",
    x: 2.41,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 3.75,
    y: 0
  }, "ow"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.15,
    y: 0
  }, "se "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-73",
    x: 13.85,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.23,
    y: 0
  }, "y c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-88",
    x: 21.02,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 23.05,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.42,
    y: 0
  }, "ego"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 31.24,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.73,
    y: 0
  }, "y"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-67",
    transform: "translate(904.09 629.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 6.64,
    y: 0
  }, "esponsive"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-115",
    x: 0,
    y: 11
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.12,
    y: 11
  }, "ebsite Design")), /*#__PURE__*/React.createElement("text", {
    className: "cls-65",
    transform: "translate(904.09 646.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-100",
    x: 0,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 0.99,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 2.17,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.85,
    y: 0
  }, "em ipsum dolor sit ame"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 23.88,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.58,
    y: 0
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 25.49,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.44,
    y: 0
  }, "onse"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 30.74,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 31.73,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.43,
    y: 0
  }, "etuer adipiscing eli"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 49.4,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.1,
    y: 0
  }, ", sed diam nonum"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-102",
    x: 66.16,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.93,
    y: 0
  }, "y nibh euismod "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 3.59
  }, "tincidu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 6.28,
    y: 3.59
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.46,
    y: 3.59
  }, "t ut lao"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 13.71,
    y: 3.59
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.4,
    y: 3.59
  }, "eet dolo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 21.81,
    y: 3.59
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.49,
    y: 3.59
  }, "e ma"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 26.86,
    y: 3.59
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.05,
    y: 3.59
  }, "na aliquam e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 39.55,
    y: 3.59
  }, "ra"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.27,
    y: 3.59
  }, "t "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 42.44,
    y: 3.59
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.45,
    y: 3.59
  }, "olutp"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-118",
    x: 48.26,
    y: 3.59
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    y: 3.59
  }, ". "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-123",
    x: 50.9,
    y: 3.59
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.3,
    y: 3.59
  }, "t wisi enim ad minim "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 71.35,
    y: 3.59
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.37,
    y: 3.59
  }, "eniam, quis "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.17
  }, "nostrud "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-125",
    x: 7.5,
    y: 7.17
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 8.57,
    y: 7.17
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.54,
    y: 7.17
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 10.61,
    y: 7.17
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.3,
    y: 7.17
  }, "ci t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 13.93,
    y: 7.17
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.96,
    y: 7.17
  }, "tion ullam"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 24.04,
    y: 7.17
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 25,
    y: 7.17
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-123",
    x: 26.18,
    y: 7.17
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.89,
    y: 7.17
  }, "per suscipit lobo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 41.7,
    y: 7.17
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.46,
    y: 7.17
  }, "tis nisl ut "))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 904.06,
    y: 662.54,
    width: 86.36,
    height: 4.91
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-59",
    transform: "translate(906.62 665.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "wh"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 2.78,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 3.81,
    y: 0
  }, "t do "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 7.83,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.82,
    y: 0
  }, "ou need?")), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m986.03,664.99c0,.81.66,1.47,1.47,1.47s1.47-.66,1.47-1.47-.66-1.47-1.47-1.47-1.47.66-1.47,1.47Zm2.1,0l-.79.79-.22-.22.57-.56-.57-.56.22-.22.79.79Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "950.63 696.88 947.24 700.26 943.86 696.88 942.62 696.88 947.24 701.5 951.87 696.88 950.63 696.88"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m917.5,712.64h70.06c4.91,0,9.09-3.23,10.56-7.66l-102.3-102.3v88.28l21.68,21.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "915.12 505.18 998.68 588.74 998.68 525.45 978.41 505.18 915.12 505.18"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/Asset 3.c25953e36e404c0563b499a0c674a114.svg";
export { ForwardRef as ReactComponent };